module.exports = __webpack_public_path__ + "static/media/cards2.757cbde9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/cards2.png
// module id = 1212
// module chunks = 0